import { RootState } from '../../rootReducer'

export const selectPublicVAPIDKey = (state: RootState) => state.pushSubscriptions.publicVAPIDKey

export const selectSubscription = (state: RootState) => state.pushSubscriptions.subscription

export const selectRegistration = (state: RootState) => state.pushSubscriptions.registration
